import React, { useRef, useEffect } from "react";
import { useModal } from "@raca2022/uikit";
import MenuLangding from "./MenuLangding";
import { BackgroundHome , FloorParalax } from "./style";
import Body from "./Body";
// import Social from "../Social";

const Home = () => {
  // const [onModalWarning] = useModal(<ModalWarning />, false);
  // const onPresentAutoRef = useRef(onModalWarning);

  // useEffect(() => {
  //   onPresentAutoRef.current();
  // }, []);

  return (
    <React.StrictMode>
      <BackgroundHome>
        <MenuLangding />
        <FloorParalax>
          <div>
            <h1>Green</h1>
            <p>Step Towards Clean And <br/> Sustainable Crypto Industry</p>
            <h1>FOUNDATION</h1>
          </div>
        </FloorParalax>
        <Body/>
      </BackgroundHome>
    </React.StrictMode>
  );
};

export default Home;
